let isPassKeyValid = false; // Global pass-key state
let isOTPAuthenticated = false; // Flag for OTP authentication
const globalPassKey = "kennynaut"; // Replace with your actual pass-key

function validatePassKey(inputKey) {
  if (inputKey === globalPassKey) {
    isPassKeyValid = true;
    alert("Pass-key verified. You can now view locked pages.");
    location.reload(); // Reload to render the content
  } else {
    alert("Invalid pass-key. Please try again.");
  }
}

function authenticateWithOTP(emailOrPhone, otp) {
  fetch(`${API_BASE_URL}/api/verify-otp`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ identifier: emailOrPhone, otp: otp }),
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        isOTPAuthenticated = true;
        alert("OTP verified. You can now view the page.");
        location.reload(); // Reload to render the page
      } else {
        alert("OTP verification failed. Please try again.");
      }
    })
    .catch((error) => {
      console.error("Error authenticating with OTP:", error);
    });
}

function displayPlaceholder(parentContainer, imageContainer, placeholderImage) {
  const placeholder = document.createElement("div");
  placeholder.className = "locked-placeholder";

  const imgElement = document.createElement("img");
  imgElement.src = placeholderImage;
  imgElement.alt = "Locked Content";

  placeholder.appendChild(imgElement);
  imageContainer.appendChild(placeholder);

  // Append the image-container to the parent container
  parentContainer.appendChild(imageContainer);
}

function renderClickableAreas(image, imgElement, clickableAreas) {
  const renderedWidth = imgElement.clientWidth;
  const renderedHeight = imgElement.clientHeight;

  image.clickable_areas.forEach((area) => {
    const areaElement = document.createElement("div");
    areaElement.id = area.id;
    areaElement.className = `clickable-area ${area.shape}`;
    areaElement.dataset.action = area.action;
    areaElement.dataset.type = area.type;

    if (area.shape === "hexagon") {
      const sideLengthPx = (area.side_length / 100) * renderedWidth;
      const hexHeight = 2 * sideLengthPx;
      const hexWidth = Math.sqrt(3) * sideLengthPx;

      areaElement.style.width = `${hexWidth}px`;
      areaElement.style.height = `${hexHeight}px`;

      const centerX = (area.x / 100) * renderedWidth;
      const centerY = (area.y / 100) * renderedHeight;
      areaElement.style.left = `${centerX - hexWidth / 2}px`;
      areaElement.style.top = `${centerY - hexHeight / 2}px`;

      const rotationAngle = area.rotation || 0;
      areaElement.style.transform = `rotate(${rotationAngle}deg)`;
    } else if (area.shape === "rectangle") {
      const rectWidth = (area.width / 100) * renderedWidth;
      const rectHeight = (area.height / 100) * renderedHeight;
      const borderRadius = area.border_radius || 0;

      areaElement.style.width = `${rectWidth}px`;
      areaElement.style.height = `${rectHeight}px`;

      const centerX = (area.x / 100) * renderedWidth;
      const centerY = (area.y / 100) * renderedHeight;
      areaElement.style.left = `${centerX - rectWidth / 2}px`;
      areaElement.style.top = `${centerY - rectHeight / 2}px`;

      areaElement.style.borderRadius = `${(borderRadius / 100) * Math.min(rectWidth, rectHeight)}px`;
    }

    areaElement.addEventListener("click", () => handleAreaClick(area));
    clickableAreas.appendChild(areaElement);
  });
}

function initializeInteractiveWebmag(data) {
  const parentContainer = document.querySelector(".interactive-image-column");
  let imagesProcessed = 0;

  data.images.forEach((image, index) => {
    const imageContainer = document.createElement("div");
    imageContainer.className = "image-container";
    imageContainer.id = `${image.id}-${index}`;

    if (image.lock_level > 0) {
      if (image.lock_level === 1 && !isPassKeyValid) {
        displayPlaceholder(parentContainer, imageContainer, image.placeholder_image);
        return;
      }
      if (image.lock_level === 2 && !isOTPAuthenticated) {
        displayPlaceholder(parentContainer, imageContainer, image.placeholder_image);
        return;
      }
    }

    const imgElement = document.createElement("img");
    imgElement.src = image.src;
    imgElement.alt = `Interactive ${image.id}`;

    const clickableAreas = document.createElement("div");
    clickableAreas.className = "clickable-areas";

    imgElement.onload = () => {
      renderClickableAreas(image, imgElement, clickableAreas);
      imagesProcessed++;

      if (imagesProcessed === data.images.length) {
        setupInitialHighlight();
      }
    };

    imageContainer.appendChild(imgElement);
    imageContainer.appendChild(clickableAreas);
    parentContainer.appendChild(imageContainer);
  });

  setupScrollToTop();
}

function handleAreaClick(area) {
  if (area.type === "scroll") {
    const targetId = area.action.replace("#", "");
    const target = document.getElementById(targetId);

    if (target) {
      const targetContainer = target.closest(".image-container");

      if (targetContainer) {
        const targetPosition = targetContainer.getBoundingClientRect().top + window.scrollY;
        const margin = window.innerHeight * 0.1;
        window.scrollTo({
          top: targetPosition - margin,
          behavior: "smooth",
        });
      }
    }
  } else if (area.type === "popup") {
    alert("This is a popup!");
  }
}

function setupScrollToTop() {
  const scrollToTopButton = document.querySelector(".scroll-to-top");

  if (scrollToTopButton) {
    scrollToTopButton.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}
